export default {
  data() {
    return {
      topicOptions: [
        { label: 'Job', value: 100 },
        { label: 'Machine', value: 200 },
        { label: 'Order Detail', value: 300 }
      ],
      actionFlagOptions: [
        { label: 'Create', value: 1 },
        { label: 'Update', value: 2 },
        { label: 'Delete', value: 4 }
      ],
      filterOptions: [
        { label: 'Property Name', value: 1 },
        { label: 'Property Name Value', value: 2 },
        { label: 'RegEx Match Include', value: 3 },
        { label: 'RegEx Match Exclude', value: 4 }
      ]
    };
  },

  methods: {
    getTopicLabel(topic) {
      const option = this.topicOptions.find(o => o.value === topic);
      return option ? option.label : 'Unknown';
    },

    getActionFlagsLabel(flags) {
      const labels = [];
      if (flags & 1) labels.push('Create');
      if (flags & 2) labels.push('Update');
      if (flags & 4) labels.push('Delete');
      return labels.join(' / ') || 'None';
    },

    parseActionFlags(flags) {
      const result = [];
      if (flags & 1) result.push(1);
      if (flags & 2) result.push(2);
      if (flags & 4) result.push(4);
      return result;
    }
  }
};
